import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Geist_Mono, Instrument_Serif, Inter_Tight } from 'next/font/google'
import { AuthProvider } from '@/components/generals/auth-provider'
import { Footer } from '@/components/generals/footer'
import { Navbar } from '@/components/generals/navbar'
import { PageTransition } from '@/components/generals/page-transition'

const sans = Inter_Tight({
    subsets: ['latin']
})

const serif = Instrument_Serif({
    subsets: ['latin'],
    weight: '400',
    style: ['normal', 'italic']
})

const mono = Geist_Mono({
    subsets: ['latin'],
    preload: false
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily};--font-app-serif:${serif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-black font-sans text-cream'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <AuthProvider>
                <a
                    href='#main'
                    className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[90] focus:rounded-full focus:bg-cream focus:px-4 focus:py-2 focus:text-sm focus:text-black'
                >
                    Skip to content
                </a>

                <Navbar />

                <Component {...pageProps} />

                <Footer />

                <PageTransition />
            </AuthProvider>
        </div>
    )
}

export default App
